import { render, staticRenderFns } from "./ResultQuestionsList.vue?vue&type=template&id=8a877d60&"
import script from "./ResultQuestionsList.vue?vue&type=script&lang=js&"
export * from "./ResultQuestionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports